<template>
  <div id="shadowQualityAcceptedList" class="common_type2">
    <div class="common_tit_wrap">
      <div class="common_page_tit">음영∙품질 개선</div>
      <div class="common_page_desc">
        저압 모뎀 웹사이트
        <template v-if="userInfoDetail.userRole === 2 || userInfoDetail.userRole === 3">
          |
          <template v-if="userInfoDetail.affiliateCode != null">
            <template v-for="afc in afcList" v-if="afc.codeValue === userInfoDetail.affiliateCode">{{afc.codeName}}</template>
          </template>
          <template v-if="userInfoDetail.officeCode != null">
            <template v-for="ofc1 in ofc1List" v-if="ofc1.codeValue === userInfoDetail.officeCode.substring(0, 5)">{{ofc1.codeName}}</template>
          </template>
        </template>
      </div>
      <div class="common_progress_wrap item5">
        <div class="common_progress_start" @click="movePage('RequestList')">요청<span v-if="mySession.userRole === 2">({{countParams.sq['1']}}건)</span></div>
        <div class="common_progress_middle pending" @click="movePage('PendingList')">보류<span v-if="mySession.userRole === 2">({{countParams.sq['2']}}건)</span></div>
        <div class="common_progress_middle on">접수<span v-if="mySession.userRole === 2">({{countParams.sq['3']}}건)</span></div>
        <div class="common_progress_middle" @click="movePage('ProgressList')">처리중<span v-if="mySession.userRole === 2">({{countParams.sq['4']}}건)</span></div>
        <div class="common_progress_end" @click="movePage('CompleteList')">완료<span v-if="mySession.userRole === 2">({{countParams.sq['5']}}건)</span></div>
      </div>
    </div>
    <div class="common_list_notice_wrap">
      <img class="common_list_notice_bg" src="../../assets/common/ic_warning.svg"/>
      <div class="common_list_notice_tit_wrap">
        <div class="common_list_notice_tit">안내</div>
        <div class="common_list_notice_desc">음영∙품질 개선 메뉴를 처음 이용하시는 분은 반드시 우측의 [매뉴얼 & 담당자]를 확인하시고 이용하여 주시기 바랍니다.</div>
      </div>
      <div class="common_list_notice_manual" @click="openManual('ShadowQualityAccepted')">매뉴얼 & 담당자</div>
    </div>
    <div class="common_list_wrap">
      <div class="common_list_top">
        <div class="common_list_top_select">
          <select v-model="selectSize" @change="search(1)">
<!--            <option value="10">10줄 표시</option>-->
<!--            <option value="20">20줄 표시</option>-->
            <option value="50">50줄 표시</option>
            <option value="100">100줄 표시</option>
            <option value="200">200줄 표시</option>
            <option value="500">500줄 표시</option>
          </select>
        </div>
        <template v-if="mySession.userRole === 2">
          <div class="btn_top btn_green_t" @click="toggleList">모뎀 요청보기({{isOffice ? '등록자' : '본부'}})</div>
        </template>
        <div class="datepicker_wrap" style="margin-left: auto;">
          <vue-datepicker-local
            v-model="searchParams.dateRange"
            inputClass="vdl_input"
            clearable
            :local="ko"/>
        </div>
        <input type="text" v-model="searchParams.searchText" style="width: 200px;"/>
        <div class="btn_top btn_blue" @click="search(1)">검색</div>
      </div>
      <div class="common_list_middle">
        <div class="common_list_head">
          <div><span><input type="checkbox" v-model="checkAll" @click.stop="onClickCheckAll"/></span></div>
          <div><span>본부</span></div>
          <div><span>사업구분</span></div>
          <div><span>주소(클릭시 전체주소 보임)</span></div>
          <div><span>이동전화번호</span></div>
          <div><span>요청사항</span></div>
          <div><span>등록일</span></div>
          <div><span>처리현황</span></div>
          <div><span>현재상태</span></div>
          <div><span>등록자</span></div>
          <div><span>삭제</span></div>
        </div>
        <div class="common_list_body">
          <div class="common_list_no_data" v-if="list.length <= 0">
            <img src="../../assets/common/bg_list_no_data.png"/>
            <span>대상 모뎀이 없습니다.</span>
          </div>
          <div :key="'sq_' + item.sqPid" v-for="item in list">
            <div><span><input type="checkbox" v-model="item.check" :value="item.sqPid" @click.stop="onClickCheckItem(item)"/></span></div>
            <div>
              <span v-if="item.officeCode != null">
                <template v-for="ofc1 in ofc1List" v-if="ofc1.codeValue === (item.officeCode.length === 5 ? item.officeCode : item.officeCode.substring(0, 5))">{{ofc1.codeName}}</template>
              </span>
              <span v-else>-</span>
            </div>
            <div>
              <span v-if="item.projectType != null">
                <template v-for="prt in prtList" v-if="prt.codeValue === item.projectType">{{prt.codeName}}</template>
              </span>
              <span v-else>-</span>
            </div>
            <div>
              <span v-if="item.postalCode != null" :title="item.addressRoad + ' ' + item.addressDetails">{{item.addressRoad + ' ' + item.addressDetails}}</span>
              <span v-else>-</span>
            </div>
            <div><span class="link fc_primary_blue" @click="showPopup('모뎀정보 보기', 'ModemViewPopup', item)">{{item.mobileNum}}</span></div>
            <div><span class="btn_status fc_white bc_status_gray" @click="showPopup('음영∙품질 개선 요청사항', 'ShadowQualityRequestPopup', item)">보기</span></div>
            <div>
              <span v-if="item.stepUpdDate != null">{{item.stepUpdDate}}</span>
              <span v-else>-</span>
            </div>
            <div>
              <!-- 처리현황: 음영품질요청 -->
<!--              <span v-if="item.progressType != null">-->
<!--                <template v-for="prg in prgList" v-if="prg.codeValue === item.progressType">{{prg.codeName}}</template>-->
<!--              </span>-->
<!--              <span v-else>-</span>-->
              <span>음영품질요청</span>
            </div>
            <div>
              <!-- 현재상태: 사용 -->
              <template v-if="item.currentState != null">
                <template v-for="crs in crsList" v-if="crs.codeValue === item.currentState">
                  <span :key="'crs_' + crs.codePid" class="btn_status fc_white" :class="item.currentState === 'CRS01' ? 'bc_status_green' : 'bc_status_red'">{{crs.codeName}}</span>
                </template>
              </template>
              <span v-else>-</span>
            </div>
            <div><span class="link fc_primary_blue" @click="showPopup(`음영∙품질 개선 요청자 정보(${item.mobileNum})`, 'MemberPopup', item)">{{item.userName}}</span></div>
            <div><span class="link fc_primary_blue" @click="deleteSelectedItem(item)">삭제</span></div>
          </div>
        </div>
      </div>
      <div class="common_bottom_wrap">
        <template v-if="mySession.userRole === 2">
          <div class="btn_bottom btn_red_t" @click="deleteSelectedItemList">선택 삭제</div>
        </template>
        <template v-if="mySession.userRole === 4">
          <div class="btn_bottom btn_yellow_t" @click="requestPending">보류(선택)</div>
          <div class="btn_bottom btn_blue_t" @click="requestComplete">접수완료(선택)</div>
        </template>
        <div class="common_list_page_wrap center_page">
          <paginate
            v-model="pageParams.page"
            :pageCount="pageParams.totalPage"
            :clickHandler="search"
            :prevText="'<'"
            :nextText="'>'"
            :containerClass="'page_wrap'">
          </paginate>
        </div>
      </div>
    </div>
    <modal name="viewPopup" classes="popup_modal" width="725px" height="auto" scrollable>
      <popup :popup-params="popupParams" @hidePopup="hidePopup"/>
    </modal>
  </div>
</template>

<script>
import VueDatepickerLocal from 'vue-datepicker-local'
import Popup from '../common/Popup.vue'
import common from '../../script/common'
import shadowQuality from '../../script/shadowQuality'
import {defaultLoadingOptions} from '../../script/defaultConfig'

export default {
  components: {VueDatepickerLocal, Popup},
  props: ['countParams'],
  data () {
    return {
      // Common
      mySession: {},
      ko: common.getDatepickerLocal(),
      userInfoDetail: JSON.parse(sessionStorage.getItem('userInfoDetail')),
      // Data
      afcList: [],
      ofcList: [],
      ofc1List: [],
      prtList: [],
      prgList: [],
      crsList: [],
      // Search
      isOffice: false,
      searchParams: {
        dateRange: [],
        searchText: ''
      },
      // List
      filter: {
        page: 1,
        size: parseInt(this.selectSize)
      },
      selectSize: '50',
      list: [],
      checkAll: false,
      selectedItemList: [],
      // Paging
      pageParams: {
        hasNext: false,
        totalElements: 0,
        totalPage: 1,
        page: 10,
        size: parseInt(this.selectSize)
      },
      // Popup
      popupParams: {
        title: '',
        component: '',
        data: {}
      }
    }
  },
  mounted () {
    common.getSession(response => {
      if (response.data.resultCode === 1 && response.data.result != null && response.data.result.userPid != null && response.data.result.userRole != null) {
        this.mySession = response.data.result
        this.$emit('getCount')
        let intervalCnt = 0
        let interval = setInterval(() => {
          if (common.checkValidateData('session', sessionStorage.getItem('afcList')) &&
            common.checkValidateData('session', sessionStorage.getItem('ofcList')) &&
            common.checkValidateData('session', sessionStorage.getItem('prtList')) &&
            common.checkValidateData('session', sessionStorage.getItem('prgList')) &&
            common.checkValidateData('session', sessionStorage.getItem('crsList'))) {
            clearInterval(interval)
            this.afcList = JSON.parse(sessionStorage.getItem('afcList'))
            this.ofcList = JSON.parse(sessionStorage.getItem('ofcList'))
            this.ofc1List = this.getOfc1List()
            this.prtList = JSON.parse(sessionStorage.getItem('prtList'))
            this.prgList = JSON.parse(sessionStorage.getItem('prgList'))
            this.crsList = JSON.parse(sessionStorage.getItem('crsList'))
            if (this.$route.params != null && this.$route.params.searchParams != null) {
              this.searchParams = this.$route.params.searchParams
              this.search(1)
            } else {
              this.search(1)
            }
          } else if (intervalCnt > 10) {
            clearInterval(interval)
            common.amsAlert('retry', '필수 데이터를 불러오지 못했습니다.')
          } else {
            intervalCnt++
          }
        }, 200)
      } else {
        common.amsAlert('general', '로그아웃 되었습니다.\n다시 로그인해주세요.')
        this.$router.replace('/Login')
      }
    })
  },
  methods: {
    // Button Action
    movePage (path) {
      this.$router.push(path)
    },
    // Common
    getOfc1List () {
      return this.ofcList.filter(item => { return item.codeLevel === 0 })
    },
    // List
    onClickCheckAll () {
      this.selectedItemList = []
      for (let i = 0; i < this.list.length; i++) {
        this.list[i].check = !this.checkAll
        if (!this.checkAll) {
          this.selectedItemList.push(this.list[i])
        }
      }
    },
    onClickCheckItem (selectedItem) {
      if (selectedItem.check) {
        this.selectedItemList = this.selectedItemList.filter(item => { return item.sqPid !== selectedItem.sqPid })
      } else {
        this.selectedItemList.push(selectedItem)
      }
      this.checkAll = this.selectedItemList.length === this.list.length
    },
    toggleList () {
      this.isOffice = !this.isOffice
      this.search(1)
    },
    search (page) {
      this.filter = {
        page: page,
        size: parseInt(this.selectSize),
        issueStep: 3
      }
      if (this.mySession.userRole === 2) {
        delete this.filter['sameOffice']
        if (this.isOffice) {
          this.filter.sameOffice = true
        }
      } else if (this.mySession.userRole === 3 || this.mySession.userRole === 4) {
        this.filter.sameOffice = true
      }
      delete this.filter['mobileNum']
      if (this.searchParams.searchText != null && this.searchParams.searchText.length > 0) {
        this.filter.mobileNum = this.searchParams.searchText
      }
      delete this.filter['updDateStart']
      delete this.filter['updDateEnd']
      if (this.searchParams.dateRange != null && this.searchParams.dateRange.length === 2) {
        this.filter.updDateStart = this.searchParams.dateRange[0]
        this.filter.updDateEnd = this.searchParams.dateRange[1]
      }
      this.updateList()
    },
    updateList () {
      let vueLoadingOverlay = this.$loading.show(defaultLoadingOptions)
      shadowQuality.getQuality(this.filter, response => {
        console.log('[음영∙품질 개선] 접수 목록', response)
        vueLoadingOverlay.hide()
        if (response.data.resultCode === 1) {
          const data = response.data.result.body
          let list = data.list
          for (let i = 0; i < list.length; i++) {
            list[i].check = false
          }
          this.list = list
          this.pageParams = {
            hasNext: data.hasNext,
            totalElements: data.totalElements,
            totalPage: data.totalPage,
            page: this.filter.page,
            size: this.filter.size
          }
        } else {
          common.amsAlert('retry', '모뎀 목록을 불러오지 못했습니다.')
          this.list = []
          this.pageParams = {
            hasNext: false,
            totalElements: 0,
            totalPage: 1,
            page: 1,
            size: this.filter.size
          }
        }
        this.checkAll = false
        this.selectedItemList = []
      })
    },
    showPopup (title, component, data) {
      this.popupParams.title = title
      this.popupParams.component = component
      this.popupParams.data = {type: 'A', data: data}
      this.$modal.show('viewPopup')
    },
    hidePopup (args) {
      this.$modal.hide('viewPopup')
      if (args != null && args.type != null) {
        if (args.type === 'L') {
          this.selectedItemList = []
          this.updateList()
        }
      }
    },
    deleteSelectedItem (item) {
      if ((this.mySession.subRole & 4) === 0) {
        common.amsAlert('general', '권한이 없습니다.')
        return
      }
      const result = common.checkUserRole(this.mySession, 2, 'delete')
      if (!result.code) {
        return
      }
      // if (this.mySession.userPid !== item.userPid) {
      //   common.amsAlert('general', '자신이 등록한 모뎀만 삭제할 수 있습니다.')
      //   return
      // }
      if (confirm('선택한 모뎀을 삭제하시겠습니까?')) {
        let vueLoadingOverlay = this.$loading.show(defaultLoadingOptions)
        shadowQuality.quality('delete', {
          list: [item.sqPid]
        }, response => {
          console.log('[음영∙품질 개선] 삭제', response)
          vueLoadingOverlay.hide()
          if (response.data.resultCode === 1) {
            common.amsAlert('general', '선택한 모뎀을 삭제했습니다.')
            this.updateList()
          } else {
            common.amsAlert('retry', '모뎀을 삭제하지 못했습니다.')
          }
        })
      }
    },
    deleteSelectedItemList () {
      if ((this.mySession.subRole & 4) === 0) {
        common.amsAlert('general', '권한이 없습니다.')
        return
      }
      const result = common.checkUserRoleAndList(this.mySession, 2, this.selectedItemList, 'delete', 'SQ')
      if (!result.code) {
        return
      }
      if (confirm('선택한 모뎀을 삭제하시겠습니까?')) {
        let vueLoadingOverlay = this.$loading.show(defaultLoadingOptions)
        shadowQuality.quality('delete', {
          list: result.list
        }, response => {
          console.log('[음영∙품질 개선] 삭제', response)
          vueLoadingOverlay.hide()
          if (response.data.resultCode === 1) {
            common.amsAlert('general', '선택한 모뎀을 삭제했습니다.')
            this.updateList()
          } else {
            common.amsAlert('retry', '모뎀을 삭제하지 못했습니다.')
          }
        })
      }
    },
    requestPending () {
      if ((this.mySession.subRole & 4) === 0) {
        common.amsAlert('general', '권한이 없습니다.')
        return
      }
      const result = common.checkUserRoleAndList(this.mySession, 4, this.selectedItemList, 'accToProc', 'SQ')
      if (!result.code) {
        return
      }
      let vueLoadingOverlay = this.$loading.show(defaultLoadingOptions)
      shadowQuality.setStep({
        issueStep: 2,
        list: result.list
      }, response => {
        console.log('[음영∙품질 개선] 보류', response)
        vueLoadingOverlay.hide()
        if (response.data.resultCode === 1) {
          common.amsAlert('general', '선택한 모뎀을 보류했습니다.')
          this.updateList()
        } else {
          common.amsAlert('retry', '모뎀을 보류하지 못했습니다.')
        }
      })
    },
    requestComplete () {
      if ((this.mySession.subRole & 4) === 0) {
        common.amsAlert('general', '권한이 없습니다.')
        return
      }
      const result = common.checkUserRoleAndList(this.mySession, 4, this.selectedItemList, 'accToProc', 'SQ')
      if (!result.code) {
        return
      }
      let vueLoadingOverlay = this.$loading.show(defaultLoadingOptions)
      shadowQuality.setStep({
        issueStep: 4,
        list: result.list
      }, response => {
        console.log('[음영∙품질 개선] 접수완료', response)
        vueLoadingOverlay.hide()
        if (response.data.resultCode === 1) {
          common.amsAlert('general', '선택한 모뎀을 접수완료했습니다.')
          this.updateList()
        } else {
          common.amsAlert('retry', '모뎀을 접수완료하지 못했습니다.')
        }
      })
    },
    openManual (type) {
      common.openManualNewWindow(type)
    }
  }
}
</script>

<style scoped>
#shadowQualityAcceptedList .common_bottom_wrap > .btn_red_t {
  margin: auto 0;
}

#shadowQualityAcceptedList .common_bottom_wrap > .btn_green_t {
  margin: auto auto auto 0;
}

#shadowQualityAcceptedList .common_list_middle > .common_list_head > div,
#shadowQualityAcceptedList .common_list_middle > .common_list_body > div > div {
  flex-shrink: 1;
  width: 100%;
}

#shadowQualityAcceptedList .common_list_middle > .common_list_head > div:nth-child(1),
#shadowQualityAcceptedList .common_list_middle > .common_list_body > div > div:nth-child(1) {
  flex-shrink: 0;
  width: 13px;
}

#shadowQualityAcceptedList .common_list_middle > .common_list_head > div:nth-child(2),
#shadowQualityAcceptedList .common_list_middle > .common_list_body > div > div:nth-child(2) {
  flex-shrink: 0;
  width: 89px;
}

#shadowQualityAcceptedList .common_list_middle > .common_list_head > div:nth-child(4),
#shadowQualityAcceptedList .common_list_middle > .common_list_body > div > div:nth-child(4) {
  flex-shrink: 0;
  width: 196px;
}

#shadowQualityAcceptedList .common_list_middle > .common_list_body > div > div:nth-child(4) > span {
  overflow: hidden;
  word-break: break-all;
  white-space: nowrap;
  text-overflow: ellipsis;
}

#shadowQualityAcceptedList .common_list_middle > .common_list_head > div:nth-child(5),
#shadowQualityAcceptedList .common_list_middle > .common_list_body > div > div:nth-child(5) {
  flex-shrink: 0;
  width: 85px;
}

#shadowQualityAcceptedList .common_list_middle > .common_list_head > div:nth-child(7),
#shadowQualityAcceptedList .common_list_middle > .common_list_body > div > div:nth-child(7) {
  flex-shrink: 0;
  width: 65px;
}

#shadowQualityAcceptedList .common_list_middle > .common_list_head > div:nth-child(11),
#shadowQualityAcceptedList .common_list_middle > .common_list_body > div > div:nth-child(11) {
  flex-shrink: 0;
  width: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/shadowQuality/ShadowQualityAcceptedList.vue